// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class ForeignCoronerDto {
    @AutoMap() name: string;
    @AutoMap() street: string;
    @AutoMap() address2: string;
    @AutoMap() postalCode: string;
    @AutoMap() city: string;
    @AutoMap() countryId: string;
    @AutoMap() phoneNumber: string;
    @AutoMap() contactPerson: string;
}